// extracted by mini-css-extract-plugin
module.exports = {"icon":"_19593"};